function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-5.627 -1.238)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.247,8.971a2.893,2.893,0,1,0,2.893,2.893A2.893,2.893,0,0,0,16.247,8.971Zm0,4.34a1.447,1.447,0,1,1,1.447-1.447,1.447,1.447,0,0,1-1.447,1.447Z",
  transform: "translate(-2.759 -2.762)",
  fill: "#d6d6d6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.047,3.539A7.862,7.862,0,0,0,6.9,13.389l5.465,8.39a1.339,1.339,0,0,0,2.244,0l5.466-8.39a7.862,7.862,0,0,0-1.028-9.85ZM18.863,12.6l-5.375,8.252L8.112,12.6a6.415,6.415,0,1,1,10.75,0Z",
  transform: "translate(0)",
  fill: "#d6d6d6"
}));

var SvgLocationPin = function SvgLocationPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.723,
    height: 21.15,
    viewBox: "0 0 15.723 21.15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location-pin.0d724681.svg";
export { ForwardRef as ReactComponent };